import { jsx as _jsx } from "react/jsx-runtime";
import InputAdornment from '@mui/material/InputAdornment';
import { styled } from '@mui/material/styles';
export const ImageAdornment = ({ position, imageUrl, size }) => {
    return (_jsx(InputAdornment, { position: position, children: _jsx(AdornmentImage, { size: size, src: imageUrl }) }));
};
const AdornmentImage = styled('img') `
    width: ${props => (props.size === 'compact' ? '20px' : '24px')};
    height: ${props => (props.size === 'compact' ? '20px' : '24px')};
    border-radius: 50%;
`;
